import qs from 'query-string';
import moment from 'moment-timezone';
import { Logger } from 'common/logger';
import { MOMENT_DATE } from 'common/constants';
import { getSelectedItems } from 'common/state.helper';

const subpagesList = [{ text: 'OVERVIEW' }, { text: 'PERFORMANCE' }, { text: 'MAINTENANCE' }];
const yesterday = moment().subtract(1, 'day');

const dateString = (date) => moment(date).format(MOMENT_DATE);

const menuBar = {
    name: 'menuBar',
    state: {
        subpagesList,
        selectedDate: yesterday,
        selectedTurbineKey: null,
    },

    reducers: {
        setSelectedDate(state, { payload: { selectedDate } }) {
            return { ...state, selectedDate };
        },

        setSelectedTurbineKey(state, { payload: { turbineKey } }) {
            return { ...state, selectedTurbineKey: turbineKey };
        },
    },

    effects: (dispatch) => ({
        checkParamsAndSetUrl({ payload: { search, pathname, navigate } }, state) {
            if (pathname.includes('reports/performance/')) {
                const turbineKey = pathname.split('/').pop();
                Logger.info(`Turbine changed to ${turbineKey}`);
                dispatch.menuBar.selectTurbine({ payload: { turbineKey } });
            }
            const { selectedDate } = getSelectedItems(state);

            if (search) {
                Logger.info(`Day changed ${search}`);
                const { day } = qs.parse(search, { ignoreQueryPrefix: true });

                if (day) {
                    const newSelectedDate = moment(day, MOMENT_DATE, true);
                    const isValid = newSelectedDate.isValid();
                    Logger.info('Selected date in checkParamsAndSetUrl', selectedDate);

                    dispatch.menuBar.selectDate({
                        payload: { selectedDate: isValid ? newSelectedDate : yesterday },
                    });

                    if (!isValid) {
                        Logger.info(`Changed invalid date to yesterday's date`);
                        navigate({
                            search: qs.stringify({ day: dateString(selectedDate) }),
                        });

                        return;
                    }

                    return;
                }
            }

            Logger.info(`Replace url to day ${selectedDate}`);

            navigate({
                search: qs.stringify({ day: dateString(selectedDate) }),
            });
        },

        selectTurbine({ payload }, state) {
            const { selectedTurbineKey } = getSelectedItems(state);
            const isSame = selectedTurbineKey === payload.turbineKey;
            if (!selectedTurbineKey || !isSame) {
                dispatch.menuBar.setSelectedTurbineKey({ payload });
            } else {
                Logger.info('Turbine is already loaded');
            }
        },

        selectDate({ payload }, state) {
            const { selectedDate } = getSelectedItems(state);
            if (!selectedDate || selectedDate.format(MOMENT_DATE) !== payload.selectedDate.format(MOMENT_DATE)) {
                dispatch.menuBar.setSelectedDate({ payload });
                Logger.info('New date selected.', { oldDate: selectedDate, newDate: payload.selectedDate });
            }
        },
    }),
};

export default menuBar;
